module.exports = __webpack_public_path__ + "static/media/cheque.b414d71c.svg";